




































































import {Component, Prop} from 'vue-property-decorator'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import {OrbitProjectCollection} from '@/model/collection/OrbitProjectCollection'
import {TokenPriced} from '@/model/resource/TokenPriced'

type FormattedTokens = {
  token: TokenPriced
  amount: number
}

@Component({})
export default class OrbitTokenCarousel extends MixinScreenSize {
  @Prop({type: OrbitProjectCollection, required: true})
  orbitProjectCollection!: OrbitProjectCollection

  tokens: FormattedTokens[] = []

  page: number = 0

  get itemsPerPage() {
    return this.isMobileS || this.isMobileL || this.isMobileM ? 2 : 3
  }

  get totalPages(): number {
    return Math.max(1, Math.ceil(this.tokens.length / this.itemsPerPage))
  }

  get start(): number {
    return this.page * this.itemsPerPage
  }

  get visible(): FormattedTokens[] {
    return this.tokens.slice(this.start, this.start + this.itemsPerPage)
  }

  get hasNextPage() {
    return this.totalPages >= 1 && this.page + 1 !== this.totalPages
  }

  get hasPreviousPage() {
    return this.totalPages >= 1 && this.page !== 0
  }

  mounted() {
    this.populateResources()
  }

  async populateResources() {
    this.$await.init('populateOrbitCollection')

    const tokenMap: Record<string, FormattedTokens> = {}

    for (const op of this.orbitProjectCollection.items) {
      const tokenId = op.tokenPriced?.idTokenPricedPk
      const amount = Number(op.amount || 0)

      if (!tokenId || !op.tokenPriced) continue

      if (!tokenMap[tokenId]) {
        tokenMap[tokenId] = {
          token: op.tokenPriced,
          amount: 0,
        }
      }

      tokenMap[tokenId].amount += amount
    }

    this.tokens = Object.values(tokenMap).map(entry => ({
      token: entry.token,
      amount: entry.amount / 10 ** (entry.token.decimals ?? 0),
    }))

    this.$await.done('populateOrbitCollection')
  }

  displayDivider(i: number) {
    if (this.tokens.length < this.itemsPerPage) {
      if (this.tokens.length === 1) {
        return false
      }

      return i === 0
    }

    if (this.itemsPerPage <= 2) {
      return i === 0 && this.page !== 2
    }

    return (
      (this.page === 0 && i === 0) ||
      (this.page === 0 && i === 1) ||
      (this.page === 1 && i === 0)
    )
  }

  nextPage() {
    this.page = (this.page + 1) % this.totalPages
  }

  prevPage() {
    this.page = (this.page - 1 + this.totalPages) % this.totalPages
  }
}
